import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { PaymentContext } from '../../PaymentOrchestrator/PaymentContextProvider';
import useBillingChangeInfo from '../hooks/useBillingChangeInfo';
import useApplePay from '../hooks/useApplePay';

const ApplePay = ({ onSuccess, onError, isMethodChange = false, isBillingDateChange = false }) => {
  const [applePayButton, setApplePayButton] = useState(null);
  const { resolvedUpgradeOffer, resolvedIsTrial, selectedPlanOverride } = useContext(PaymentContext);
  const {
    billingStartDate,
    nextBillingDate,
    remainingTimeUntilDate,
    price: offerPrice,
    billingFrequency: offerBillingFrequency,
    proRataPrice,
    isProRataMovement,
    changeBillingDatePaymentValue,
  } = useBillingChangeInfo({
    upgradeOffer: resolvedUpgradeOffer,
    isTrial: resolvedIsTrial,
  });
  const price = isBillingDateChange ? undefined : selectedPlanOverride?.price ?? offerPrice;
  const billingFrequency = isBillingDateChange
    ? undefined
    : selectedPlanOverride?.billingFrequency ?? offerBillingFrequency;

  const applePayRef = useCallback(node => {
    if (node !== null) {
      setApplePayButton(node);
    }
  }, []);

  const billingDetails = {
    isMethodChange,
    isBillingDateChange,
    changeBillingDatePaymentValue,
    upgradeOffer: resolvedUpgradeOffer,
    isTrial: resolvedIsTrial,
    price,
    billingFrequency,
    proRataPrice,
    isProRataMovement,
    billingStartDate,
    nextBillingDate,
    remainingTimeUntilDate,
  };

  useApplePay(applePayButton, billingDetails, onSuccess, onError);

  return (
    <apple-pay-button
      data-automation-test-element="apple-pay-button"
      ref={applePayRef}
      id="apple-pay-btn"
      buttonstyle="black"
      type="pay"
      locale="en-GB"
      aria-label="Pay with Apple Pay"
      role="button"
    />
  );
};

ApplePay.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  isMethodChange: PropTypes.bool,
  isBillingDateChange: PropTypes.bool,
};

export default ApplePay;
